import { LOCAL_STORAGE_KEY } from '../constants';
import type { LoggedInUserSession, Session } from '../types';

export function hasFutureExpiry(expiresAt: number, threshold: number) {
  const now = Math.round(Date.now() / 1000);
  return expiresAt > now + threshold;
}

export function getLsLoginSession(storageKey: string = LOCAL_STORAGE_KEY): Session | null {
  console.debug('getLoginSession');
  const sessionJson = localStorage.getItem(`${storageKey}.data`);
  if (sessionJson) {
    return JSON.parse(sessionJson) as LoggedInUserSession;
  }
  return null;
}

export function getLsSession(storageKey: string = LOCAL_STORAGE_KEY): Session | null {
  console.debug('getLsSession');
  const sessionJson = localStorage.getItem(`${storageKey}.data`);
  if (sessionJson) {
    const session = JSON.parse(sessionJson);
    if (session.accessTokenExpiresAt && typeof session.accessTokenExpiresAt === 'string') {
      session.accessTokenExpiresAt = parseInt(session.accessTokenExpiresAt, 10);
    }

    // Refresh creds live in the HttpOnly cookie — discard pre-split-token rows.
    if (!session.accessTokenExpiresAt) {
      console.warn('Session data is incomplete (no accessTokenExpiresAt); clearing local storage');
      clearLsSession(storageKey);
      return null;
    }

    // Do NOT gate on token lifetime — an expired access token is recoverable
    // via auth.refresh(); only refresh() failure should force re-auth (RFC 6749 §6).
    if (!session.isLoggedIn) {
      console.warn('Session is not logged in, clearing local storage');
      clearLsSession(storageKey);
      return null;
    }

    return session as Session;
  }
  return null;
}

export function setLsSession(session: Session, storageKey: string = LOCAL_STORAGE_KEY) {
  // Never log the session itself — it carries the JWT access token.
  console.debug('setLsSession');
  localStorage.setItem(`${storageKey}.data`, JSON.stringify(session));
}

export function clearLsSession(storageKey: string = LOCAL_STORAGE_KEY) {
  console.debug('clearLsSession');
  localStorage.removeItem(`${storageKey}.data`);
}
